/** EXAMPLE

{
    "p": "0", // the symbol index in the grid mask "0000011100000000000000000"
    "m": "2", // value to be applied
    "total": ["3", "1", "1", "1", "1"] // final multipliers after operation
}
*/
import maskIndexToPosition from "./mask-index-to-position";
export default function (data) {
    const reels = 5;
    const parsed = {
        value: parseInt(data.m),
        position: maskIndexToPosition(data.p, reels),
        total: data.total.map((item)=>{return parseInt(item);}),
        parsed: true
    };
    return parsed;
}